import { isPlatformServer } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { ApplicationConfig } from '../../config/config';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

@Component({
  selector: 'ngc-app-sec-links-seo',
  templateUrl: 'app-secondary-links-seo.component.html'
})
export class AppSecondaryLinksSEOComponent implements OnInit, OnDestroy {
  linkType = ['secondarynav', 'sky-miles', 'more'];
  mainNavigation: any[] = [];
  contentChild: any[] = [];
  secondaryNavigationResponse: any;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private config: ApplicationConfig,
    private cookieHelper: CookieHelper,
    private injector: Injector,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    let countryCode = this.cookieHelper.getCountryCode();
    if (this.config.onServer) {
      const requestObject = this.injector.get('REQUEST_TOKEN');
      countryCode = requestObject.query['loc'];
    }
    if (
      countryCode === undefined ||
      countryCode === null ||
      countryCode === ''
    ) {
      countryCode = this.config.get('APP_DEFAULT_COUNTRY');
    }
    if (isPlatformServer(this.platformId)) {
      this.updateContent(countryCode);
    }
  }

  updateContent(countryCode) {
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe = this.contentService
        .contentHeaderFooterForSEO(countryCode)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.secondaryNavigationResponse =
                data.header.secondaryNavigation;
              if (
                this.secondaryNavigationResponse !== undefined &&
                this.secondaryNavigationResponse !== null
              ) {
                for (const secNav of this.secondaryNavigationResponse) {
                  if (
                    secNav !== undefined &&
                    secNav !== null &&
                    secNav.details !== undefined &&
                    secNav.details !== null
                  ) {
                    if (
                      secNav.details.mainNavigation !== undefined &&
                      secNav.details.mainNavigation !== null
                    ) {
                      for (const secNavDetailsMainObj of secNav.details
                        .mainNavigation) {
                        if (
                          secNavDetailsMainObj !== undefined &&
                          secNavDetailsMainObj !== null
                        ) {
                          this.mainNavigation.push(secNavDetailsMainObj);
                        }
                      }
                    }
                    if (
                      secNav.details.childPages !== undefined &&
                      secNav.details.childPages !== null
                    ) {
                      for (const secNavDetailsChildObj of secNav.details
                        .childPages) {
                        if (
                          secNavDetailsChildObj !== undefined &&
                          secNavDetailsChildObj !== null
                        ) {
                          this.contentChild.push(secNavDetailsChildObj);
                        }
                      }
                    }
                  }
                }
              }
              this.cdf.detectChanges();
            }
          },
          (err) => {
            if (!isPlatformServer(this.platformId)) {
              this.loggingService.log('Caught Error: ' + err);
            }
          }
        );
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
